import Vue from 'vue'

//list页面公共table
import listTable from './listTable'
Vue.component('listTable', listTable)
//tabs标签
import tabs from './tabs'
Vue.component('tabs', tabs)
//子公司选择框
import childCom from './childCom'
Vue.component('childCom', childCom)
//预警选择框
import warns from './warns'
Vue.component('warns', warns)
//图片浏览组件
import vuePictureViewer from '../lib/index.js'
Vue.use(vuePictureViewer)


// WEBPACK FOOTER //
// ./src/components/globle/index.js